import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';

const Truck = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return (
        <g id={'guts'}>
            <path
                d='M14.0645 1V11C14.0645 12.1 13.1645 13 12.0645 13H1.06445V5C1.06445 2.79 2.85445 1 5.06445 1H14.0645Z'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M21.0645 13V16C21.0645 17.66 19.7245 19 18.0645 19H17.0645C17.0645 17.9 16.1645 17 15.0645 17C13.9645 17 13.0645 17.9 13.0645
                19H9.06445C9.06445 17.9 8.16445 17 7.06445 17C5.96445 17 5.06445 17.9 5.06445 19H4.06445C2.40445 19 1.06445 17.66 1.06445 16V13H12.0645C13.1645
                13 14.0645 12.1 14.0645 11V4H15.9044C16.6244 4 17.2844 4.39001 17.6444 5.01001L19.3545 8H18.0645C17.5145
                8 17.0645 8.45 17.0645 9V12C17.0645 12.55 17.5145 13 18.0645 13H21.0645Z'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M7.06445 21C8.16902 21 9.06445 20.1046 9.06445 19C9.06445 17.8954 8.16902 17 7.06445 17C5.95988
                17 5.06445 17.8954 5.06445 19C5.06445 20.1046 5.95988 21 7.06445 21Z'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M15.0645 21C16.169 21 17.0645 20.1046 17.0645 19C17.0645 17.8954 16.169 17 15.0645
                17C13.9599 17 13.0645 17.8954 13.0645 19C13.0645 20.1046 13.9599 21 15.0645 21Z'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M21.0645 11V13H18.0645C17.5145 13 17.0645 12.55 17.0645 12V9C17.0645 8.45 17.5145 8 18.0645 8H19.3545L21.0645 11Z'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
    );
};

export default createSvg(
    Truck,
    'Truck',
);
